import type { Niche } from "@/shared/lib/types"
import { TaxonomyRail } from "./taxonomy-rail"

interface NicheCardsProps {
	niches: Niche[]
	selectedNicheId?: string
}

export function NicheCards({ niches, selectedNicheId }: NicheCardsProps) {
	return (
		<TaxonomyRail items={niches} selectedId={selectedNicheId} getPath={(item) => `/n/${item.id}`} />
	)
}
